import { render, staticRenderFns } from "./HivesNavigation.vue?vue&type=template&id=ba359bf8&"
import script from "./HivesNavigation.vue?vue&type=script&lang=js&"
export * from "./HivesNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports